
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 600 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6Cf","d":"M0 0h600v300H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M200 274l100-14 100 14L300 27z"}}),_c('path',{attrs:{"d":"M213.5 274l86.5-14 86.5 14L300 60z"}}),_c('path',{attrs:{"fill":"#FCD116","d":"M200 274h200L300 150z"}})])
          )
        }
      }
    